const coordinates = [
	{
		"country": "AD",
		"latitude": 42.5,
		"longitude": 1.5
	},
	{
		"country": "AE",
		"latitude": 24,
		"longitude": 54
	},
	{
		"country": "AF",
		"latitude": 33,
		"longitude": 65
	},
	{
		"country": "AG",
		"latitude": 17.05,
		"longitude": -61.8
	},
	{
		"country": "AI",
		"latitude": 18.25,
		"longitude": -63.1667
	},
	{
		"country": "AL",
		"latitude": 41,
		"longitude": 20
	},
	{
		"country": "AM",
		"latitude": 40,
		"longitude": 45
	},
	{
		"country": "AO",
		"latitude": -12.5,
		"longitude": 18.5
	},
	{
		"country": "AQ",
		"latitude": -90,
		"longitude": 0
	},
	{
		"country": "AR",
		"latitude": -34,
		"longitude": -64
	},
	{
		"country": "AS",
		"latitude": -14.3333,
		"longitude": -170
	},
	{
		"country": "AT",
		"latitude": 47.3333,
		"longitude": 13.3333
	},
	{
		"country": "AU",
		"latitude": -27,
		"longitude": 133
	},
	{
		"country": "AW",
		"latitude": 12.5,
		"longitude": -69.9667
	},
	{
		"country": "AX",
		"latitude": 60.15,
		"longitude": 20
	},
	{
		"country": "AZ",
		"latitude": 40.5,
		"longitude": 47.5
	},
	{
		"country": "BA",
		"latitude": 44,
		"longitude": 18
	},
	{
		"country": "BB",
		"latitude": 13.1667,
		"longitude": -59.5333
	},
	{
		"country": "BD",
		"latitude": 24,
		"longitude": 90
	},
	{
		"country": "BE",
		"latitude": 50.8333,
		"longitude": 4
	},
	{
		"country": "BF",
		"latitude": 13,
		"longitude": -2
	},
	{
		"country": "BG",
		"latitude": 43,
		"longitude": 25
	},
	{
		"country": "BH",
		"latitude": 26,
		"longitude": 50.55
	},
	{
		"country": "BI",
		"latitude": -3.5,
		"longitude": 30
	},
	{
		"country": "BJ",
		"latitude": 9.5,
		"longitude": 2.25
	},
	{
		"country": "BL",
		"latitude": 17.9,
		"longitude": -62.8333
	},
	{
		"country": "BM",
		"latitude": 32.3333,
		"longitude": -64.75
	},
	{
		"country": "BN",
		"latitude": 4.5,
		"longitude": 114.6667
	},
	{
		"country": "BO",
		"latitude": -17,
		"longitude": -65
	},
	{
		"country": "BQ",
		"latitude": 17.48268,
		"longitude": -62.98324
	},
	{
		"country": "BR",
		"latitude": -10,
		"longitude": -55
	},
	{
		"country": "BS",
		"latitude": 24.25,
		"longitude": -76
	},
	{
		"country": "BT",
		"latitude": 27.5,
		"longitude": 90.5
	},
	{
		"country": "BV",
		"latitude": -54.4333,
		"longitude": 3.4
	},
	{
		"country": "BW",
		"latitude": -22,
		"longitude": 24
	},
	{
		"country": "BY",
		"latitude": 53,
		"longitude": 28
	},
	{
		"country": "BZ",
		"latitude": 17.25,
		"longitude": -88.75
	},
	{
		"country": "CA",
		"latitude": 60,
		"longitude": -95
	},
	{
		"country": "CC",
		"latitude": -12.5,
		"longitude": 96.8333
	},
	{
		"country": "CD",
		"latitude": 0,
		"longitude": 25
	},
	{
		"country": "CF",
		"latitude": 7,
		"longitude": 21
	},
	{
		"country": "CG",
		"latitude": -1,
		"longitude": 15
	},
	{
		"country": "CH",
		"latitude": 47,
		"longitude": 8
	},
	{
		"country": "CI",
		"latitude": 8,
		"longitude": -5
	},
	{
		"country": "CK",
		"latitude": -21.2333,
		"longitude": -159.7667
	},
	{
		"country": "CL",
		"latitude": -30,
		"longitude": -71
	},
	{
		"country": "CM",
		"latitude": 6,
		"longitude": 12
	},
	{
		"country": "CN",
		"latitude": 35,
		"longitude": 105
	},
	{
		"country": "CO",
		"latitude": 4,
		"longitude": -72
	},
	{
		"country": "CR",
		"latitude": 10,
		"longitude": -84
	},
	{
		"country": "CU",
		"latitude": 21.5,
		"longitude": -80
	},
	{
		"country": "CV",
		"latitude": 16,
		"longitude": -24
	},
	{
		"country": "CW",
		"latitude": 12.1833,
		"longitude": -68.9333
	},
	{
		"country": "CX",
		"latitude": -10.5,
		"longitude": 105.6667
	},
	{
		"country": "CY",
		"latitude": 35,
		"longitude": 33
	},
	{
		"country": "CZ",
		"latitude": 49.75,
		"longitude": 15.5
	},
	{
		"country": "DE",
		"latitude": 51,
		"longitude": 9
	},
	{
		"country": "DJ",
		"latitude": 11.5,
		"longitude": 43
	},
	{
		"country": "DK",
		"latitude": 56,
		"longitude": 10
	},
	{
		"country": "DM",
		"latitude": 15.4167,
		"longitude": -61.3333
	},
	{
		"country": "DO",
		"latitude": 19,
		"longitude": -70.6667
	},
	{
		"country": "DZ",
		"latitude": 28,
		"longitude": 3
	},
	{
		"country": "EC",
		"latitude": -2,
		"longitude": -77.5
	},
	{
		"country": "EE",
		"latitude": 59,
		"longitude": 26
	},
	{
		"country": "EG",
		"latitude": 27,
		"longitude": 30
	},
	{
		"country": "EH",
		"latitude": 24.5,
		"longitude": -13
	},
	{
		"country": "ER",
		"latitude": 15,
		"longitude": 39
	},
	{
		"country": "ES",
		"latitude": 40,
		"longitude": -4
	},
	{
		"country": "ET",
		"latitude": 8,
		"longitude": 38
	},
	{
		"country": "FI",
		"latitude": 64,
		"longitude": 26
	},
	{
		"country": "FJ",
		"latitude": -18,
		"longitude": 175
	},
	{
		"country": "FK",
		"latitude": -51.75,
		"longitude": -59
	},
	{
		"country": "FM",
		"latitude": 6.9167,
		"longitude": 158.25
	},
	{
		"country": "FO",
		"latitude": 62,
		"longitude": -7
	},
	{
		"country": "FR",
		"latitude": 46,
		"longitude": 2
	},
	{
		"country": "GA",
		"latitude": -1,
		"longitude": 11.75
	},
	{
		"country": "GB",
		"latitude": 54,
		"longitude": -2
	},
	{
		"country": "GD",
		"latitude": 12.1167,
		"longitude": -61.6667
	},
	{
		"country": "GE",
		"latitude": 42,
		"longitude": 43.5
	},
	{
		"country": "GF",
		"latitude": 4,
		"longitude": -53
	},
	{
		"country": "GG",
		"latitude": 49.45,
		"longitude": -2.58
	},
	{
		"country": "GH",
		"latitude": 8,
		"longitude": -2
	},
	{
		"country": "GI",
		"latitude": 36.1833,
		"longitude": -5.3667
	},
	{
		"country": "GL",
		"latitude": 72,
		"longitude": -40
	},
	{
		"country": "GM",
		"latitude": 13.4667,
		"longitude": -16.5667
	},
	{
		"country": "GN",
		"latitude": 11,
		"longitude": -10
	},
	{
		"country": "GP",
		"latitude": 16.25,
		"longitude": -61.5833
	},
	{
		"country": "GQ",
		"latitude": 2,
		"longitude": 10
	},
	{
		"country": "GR",
		"latitude": 39,
		"longitude": 22
	},
	{
		"country": "GS",
		"latitude": -54.5,
		"longitude": -37
	},
	{
		"country": "GT",
		"latitude": 15.5,
		"longitude": -90.25
	},
	{
		"country": "GU",
		"latitude": 13.4667,
		"longitude": 144.7833
	},
	{
		"country": "GW",
		"latitude": 12,
		"longitude": -15
	},
	{
		"country": "GY",
		"latitude": 5,
		"longitude": -59
	},
	{
		"country": "HK",
		"latitude": 22.25,
		"longitude": 114.1667
	},
	{
		"country": "HM",
		"latitude": -53.1,
		"longitude": 72.5167
	},
	{
		"country": "HN",
		"latitude": 15,
		"longitude": -86.5
	},
	{
		"country": "HR",
		"latitude": 45.1667,
		"longitude": 15.5
	},
	{
		"country": "HT",
		"latitude": 19,
		"longitude": -72.4167
	},
	{
		"country": "HU",
		"latitude": 47,
		"longitude": 20
	},
	{
		"country": "ID",
		"latitude": -5,
		"longitude": 120
	},
	{
		"country": "IE",
		"latitude": 53,
		"longitude": -8
	},
	{
		"country": "IL",
		"latitude": 31.5,
		"longitude": 34.75
	},
	{
		"country": "IM",
		"latitude": 54.23,
		"longitude": -4.57
	},
	{
		"country": "IN",
		"latitude": 20,
		"longitude": 77
	},
	{
		"country": "IO",
		"latitude": -6,
		"longitude": 71.5
	},
	{
		"country": "IQ",
		"latitude": 33,
		"longitude": 44
	},
	{
		"country": "IR",
		"latitude": 32,
		"longitude": 53
	},
	{
		"country": "IS",
		"latitude": 65,
		"longitude": -18
	},
	{
		"country": "IT",
		"latitude": 42.8333,
		"longitude": 12.8333
	},
	{
		"country": "JE",
		"latitude": 49.2167,
		"longitude": -2.1167
	},
	{
		"country": "JM",
		"latitude": 18.25,
		"longitude": -77.5
	},
	{
		"country": "JO",
		"latitude": 31,
		"longitude": 36
	},
	{
		"country": "JP",
		"latitude": 36,
		"longitude": 138
	},
	{
		"country": "KE",
		"latitude": 1,
		"longitude": 38
	},
	{
		"country": "KG",
		"latitude": 41,
		"longitude": 75
	},
	{
		"country": "KH",
		"latitude": 13,
		"longitude": 105
	},
	{
		"country": "KI",
		"latitude": 1.4167,
		"longitude": 173
	},
	{
		"country": "KM",
		"latitude": -12.1667,
		"longitude": 44.25
	},
	{
		"country": "KN",
		"latitude": 17.3333,
		"longitude": -62.75
	},
	{
		"country": "KP",
		"latitude": 40,
		"longitude": 127
	},
	{
		"country": "KR",
		"latitude": 37,
		"longitude": 127.5
	},
	{
		"country": "KW",
		"latitude": 29.3375,
		"longitude": 47.6581
	},
	{
		"country": "KY",
		"latitude": 19.5,
		"longitude": -80.5
	},
	{
		"country": "KZ",
		"latitude": 48,
		"longitude": 68
	},
	{
		"country": "LA",
		"latitude": 18,
		"longitude": 105
	},
	{
		"country": "LB",
		"latitude": 33.8333,
		"longitude": 35.8333
	},
	{
		"country": "LC",
		"latitude": 13.8833,
		"longitude": -61.1333
	},
	{
		"country": "LI",
		"latitude": 47.1667,
		"longitude": 9.5333
	},
	{
		"country": "LK",
		"latitude": 7,
		"longitude": 81
	},
	{
		"country": "LR",
		"latitude": 6.5,
		"longitude": -9.5
	},
	{
		"country": "LS",
		"latitude": -29.5,
		"longitude": 28.5
	},
	{
		"country": "LT",
		"latitude": 56,
		"longitude": 24
	},
	{
		"country": "LU",
		"latitude": 49.75,
		"longitude": 6.1667
	},
	{
		"country": "LV",
		"latitude": 57,
		"longitude": 25
	},
	{
		"country": "LY",
		"latitude": 25,
		"longitude": 17
	},
	{
		"country": "MA",
		"latitude": 32,
		"longitude": -5
	},
	{
		"country": "MC",
		"latitude": 43.7333,
		"longitude": 7.4
	},
	{
		"country": "MD",
		"latitude": 47,
		"longitude": 29
	},
	{
		"country": "ME",
		"latitude": 42,
		"longitude": 19
	},
	{
		"country": "MF",
		"latitude": 18.05,
		"longitude": -63.08
	},
	{
		"country": "MG",
		"latitude": -20,
		"longitude": 47
	},
	{
		"country": "MH",
		"latitude": 9,
		"longitude": 168
	},
	{
		"country": "MK",
		"latitude": 41.8333,
		"longitude": 22
	},
	{
		"country": "ML",
		"latitude": 17,
		"longitude": -4
	},
	{
		"country": "MM",
		"latitude": 22,
		"longitude": 98
	},
	{
		"country": "MN",
		"latitude": 46,
		"longitude": 105
	},
	{
		"country": "MO",
		"latitude": 22.1667,
		"longitude": 113.55
	},
	{
		"country": "MP",
		"latitude": 15.2,
		"longitude": 145.75
	},
	{
		"country": "MQ",
		"latitude": 14.6667,
		"longitude": -61
	},
	{
		"country": "MR",
		"latitude": 20,
		"longitude": -12
	},
	{
		"country": "MS",
		"latitude": 16.75,
		"longitude": -62.2
	},
	{
		"country": "MT",
		"latitude": 35.8333,
		"longitude": 14.5833
	},
	{
		"country": "MU",
		"latitude": -20.2833,
		"longitude": 57.55
	},
	{
		"country": "MV",
		"latitude": 3.25,
		"longitude": 73
	},
	{
		"country": "MW",
		"latitude": -13.5,
		"longitude": 34
	},
	{
		"country": "MX",
		"latitude": 23,
		"longitude": -102
	},
	{
		"country": "MY",
		"latitude": 2.5,
		"longitude": 112.5
	},
	{
		"country": "MZ",
		"latitude": -18.25,
		"longitude": 35
	},
	{
		"country": "NA",
		"latitude": -22,
		"longitude": 17
	},
	{
		"country": "NC",
		"latitude": -21.5,
		"longitude": 165.5
	},
	{
		"country": "NE",
		"latitude": 16,
		"longitude": 8
	},
	{
		"country": "NF",
		"latitude": -29.0333,
		"longitude": 167.95
	},
	{
		"country": "NG",
		"latitude": 10,
		"longitude": 8
	},
	{
		"country": "NI",
		"latitude": 13,
		"longitude": -85
	},
	{
		"country": "NL",
		"latitude": 52.5,
		"longitude": 5.75
	},
	{
		"country": "NO",
		"latitude": 62,
		"longitude": 10
	},
	{
		"country": "NP",
		"latitude": 28,
		"longitude": 84
	},
	{
		"country": "NR",
		"latitude": -0.5333,
		"longitude": 166.9167
	},
	{
		"country": "NU",
		"latitude": -19.0333,
		"longitude": -169.8667
	},
	{
		"country": "NZ",
		"latitude": -41,
		"longitude": 174
	},
	{
		"country": "OM",
		"latitude": 21,
		"longitude": 57
	},
	{
		"country": "PA",
		"latitude": 9,
		"longitude": -80
	},
	{
		"country": "PE",
		"latitude": -10,
		"longitude": -76
	},
	{
		"country": "PF",
		"latitude": -15,
		"longitude": -140
	},
	{
		"country": "PG",
		"latitude": -6,
		"longitude": 147
	},
	{
		"country": "PH",
		"latitude": 13,
		"longitude": 122
	},
	{
		"country": "PK",
		"latitude": 30,
		"longitude": 70
	},
	{
		"country": "PL",
		"latitude": 52,
		"longitude": 20
	},
	{
		"country": "PM",
		"latitude": 46.8333,
		"longitude": -56.3333
	},
	{
		"country": "PN",
		"latitude": -24.36146,
		"longitude": -128.3163761
	},
	{
		"country": "PR",
		"latitude": 18.25,
		"longitude": -66.5
	},
	{
		"country": "PS",
		"latitude": 32,
		"longitude": 35.25
	},
	{
		"country": "PT",
		"latitude": 39.5,
		"longitude": -8
	},
	{
		"country": "PW",
		"latitude": 7.5,
		"longitude": 134.5
	},
	{
		"country": "PY",
		"latitude": -23,
		"longitude": -58
	},
	{
		"country": "QA",
		"latitude": 25.5,
		"longitude": 51.25
	},
	{
		"country": "RE",
		"latitude": -21.1,
		"longitude": 55.6
	},
	{
		"country": "RO",
		"latitude": 46,
		"longitude": 25
	},
	{
		"country": "RS",
		"latitude": 44,
		"longitude": 21
	},
	{
		"country": "RU",
		"latitude": 60,
		"longitude": 100
	},
	{
		"country": "RW",
		"latitude": -2,
		"longitude": 30
	},
	{
		"country": "SA",
		"latitude": 25,
		"longitude": 45
	},
	{
		"country": "SB",
		"latitude": -8,
		"longitude": 159
	},
	{
		"country": "SC",
		"latitude": -4.5833,
		"longitude": 55.6667
	},
	{
		"country": "SD",
		"latitude": 15,
		"longitude": 30
	},
	{
		"country": "SE",
		"latitude": 62,
		"longitude": 15
	},
	{
		"country": "SG",
		"latitude": 1.3667,
		"longitude": 103.8
	},
	{
		"country": "SH",
		"latitude": -15.9333,
		"longitude": -5.7
	},
	{
		"country": "SI",
		"latitude": 46,
		"longitude": 15
	},
	{
		"country": "SJ",
		"latitude": 78,
		"longitude": 20
	},
	{
		"country": "SK",
		"latitude": 48.6667,
		"longitude": 19.5
	},
	{
		"country": "SL",
		"latitude": 8.5,
		"longitude": -11.5
	},
	{
		"country": "SM",
		"latitude": 43.7667,
		"longitude": 12.4167
	},
	{
		"country": "SN",
		"latitude": 14,
		"longitude": -14
	},
	{
		"country": "SO",
		"latitude": 10,
		"longitude": 49
	},
	{
		"country": "SR",
		"latitude": 4,
		"longitude": -56
	},
	{
		"country": "SS",
		"latitude": 4.85,
		"longitude": 31.6
	},
	{
		"country": "ST",
		"latitude": 1,
		"longitude": 7
	},
	{
		"country": "SV",
		"latitude": 13.8333,
		"longitude": -88.9167
	},
	{
		"country": "SX",
		"latitude": 18.05,
		"longitude": -63.08
	},
	{
		"country": "SY",
		"latitude": 35,
		"longitude": 38
	},
	{
		"country": "SZ",
		"latitude": -26.5,
		"longitude": 31.5
	},
	{
		"country": "TC",
		"latitude": 21.75,
		"longitude": -71.5833
	},
	{
		"country": "TD",
		"latitude": 15,
		"longitude": 19
	},
	{
		"country": "TF",
		"latitude": -43,
		"longitude": 67
	},
	{
		"country": "TG",
		"latitude": 8,
		"longitude": 1.1667
	},
	{
		"country": "TH",
		"latitude": 15,
		"longitude": 100
	},
	{
		"country": "TJ",
		"latitude": 39,
		"longitude": 71
	},
	{
		"country": "TK",
		"latitude": -9,
		"longitude": -172
	},
	{
		"country": "TL",
		"latitude": -8.5,
		"longitude": 125.55
	},
	{
		"country": "TM",
		"latitude": 40,
		"longitude": 60
	},
	{
		"country": "TN",
		"latitude": 34,
		"longitude": 9
	},
	{
		"country": "TO",
		"latitude": -20,
		"longitude": -175
	},
	{
		"country": "TR",
		"latitude": 39,
		"longitude": 35
	},
	{
		"country": "TT",
		"latitude": 11,
		"longitude": -61
	},
	{
		"country": "TV",
		"latitude": -8,
		"longitude": 178
	},
	{
		"country": "TW",
		"latitude": 23.5,
		"longitude": 121
	},
	{
		"country": "TZ",
		"latitude": -6,
		"longitude": 35
	},
	{
		"country": "UA",
		"latitude": 49,
		"longitude": 32
	},
	{
		"country": "UG",
		"latitude": 1,
		"longitude": 32
	},
	{
		"country": "UM",
		"latitude": 19.2833,
		"longitude": 166.6
	},
	{
		"country": "US",
		"latitude": 38,
		"longitude": -97
	},
	{
		"country": "UY",
		"latitude": -33,
		"longitude": -56
	},
	{
		"country": "UZ",
		"latitude": 41,
		"longitude": 64
	},
	{
		"country": "VA",
		"latitude": 41.9,
		"longitude": 12.45
	},
	{
		"country": "VC",
		"latitude": 13.25,
		"longitude": -61.2
	},
	{
		"country": "VE",
		"latitude": 8,
		"longitude": -66
	},
	{
		"country": "VG",
		"latitude": 18.5,
		"longitude": -64.5
	},
	{
		"country": "VI",
		"latitude": 18.3333,
		"longitude": -64.8333
	},
	{
		"country": "VN",
		"latitude": 16,
		"longitude": 106
	},
	{
		"country": "VU",
		"latitude": -16,
		"longitude": 167
	},
	{
		"country": "WF",
		"latitude": -13.3,
		"longitude": -176.2
	},
	{
		"country": "WS",
		"latitude": -13.5833,
		"longitude": -172.3333
	},
	{
		"country": "YE",
		"latitude": 15,
		"longitude": 48
	},
	{
		"country": "YT",
		"latitude": -12.8333,
		"longitude": 45.1667
	},
	{
		"country": "ZA",
		"latitude": -29,
		"longitude": 24
	},
	{
		"country": "ZM",
		"latitude": -15,
		"longitude": 30
	},
	{
		"country": "ZW",
		"latitude": -20,
		"longitude": 30
	}
]

export default coordinates;